import { connect } from 'react-redux';
import LoginHandlerComponent from './login-callback-component';
import { fetch } from './redux/actions';

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps, { fetch })(LoginHandlerComponent);
